import { createSlice } from "@reduxjs/toolkit";
import { authApi } from "./authApi";

const initialState = {
  userData: null,
  token: null,
  decriptedTokenInfo: {},
  isFirstAccess: undefined,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    getLoginData: (state, action) => {
      state.userData = action.payload.userData;
      state.token = action.payload.token;
      state.isFirstAccess = action.payload.isFirstAccess;
    },
    getDecriptedTokenInfo: (state, action) => {
      state.decriptedTokenInfo = action.payload;
    },
    logoutUser: (state) => {
      state.userData = null;
      state.token = null;
      state.decriptedTokenInfo = {};
    },
    registerUser: (state, action) => {
      state.userData = action.payload.userData;
      state.token = action.payload.token;
    },
  },
  // extraReducers: (builder) => {
  //   builder.addMatcher(
  //     authApi.endpoints.loginUser.matchFulfilled,
  //     (state, { payload }) => {
  //       state.userData = payload.userData;
  //       state.token = payload.token;
  //     }
  //   );
  // },
});

export const selectAuthData = (state) => state.auth;

export const { getLoginData, getDecriptedTokenInfo, logoutUser, registerUser } =
  authSlice.actions;
export default authSlice.reducer;
